export default __webpack_public_path__ + "static/media/logo_2.fe60bd52.png";